"use strict";

import angular from "angular";


angular.module("nucont.accounting.company.demonstrations").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state(
        "nucont.accounting.company.demonstrations.accounting",
        {
            url: "/demonstracoes/contabil",
            views: {
                "demonstrationView@nucont.accounting.company.demonstrations": {
                    component: "accountingDemonstrationsComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            params: {
                source: { value: "contabil", dynamic: true }
            }
        }
    );
}
